import { createFcmDetails } from '../../shared/factory';
import type { FcmDetailsMap } from '../../shared/types';

export function createRegexPagesFcmDetails<N extends string>(
	name: N,
	{ scriptName, context }: { scriptName: string; context?: string },
): FcmDetailsMap<N> {
	return createFcmDetails(name, {
		owner: 'FE framework squad',
		context,
		description: `Used to enable the loading of the ${scriptName} script on specific pages, based on a list of regular expressions.
			https://regexr.com/ can be used to create the regular expressions.
			It is recommended to match the url as close as possible by doing the following:
				- prefix the regular expression with ^
				- suffix the regular expression with $
				- use /? before the $ to match urls ending with a / (e.g. /p/my-slug/)
				- use [^/]+ to match a section of the path in between slashes (/)
			Examples:
				- petition page: "^/p/[^/]+/?$"
				- SAP page: "^/start-a-petition/?$"
			Please ask an engineer for help if you aren't sure about how this works.

			WARNING: this is only compatible with corgi pages.`,
		mergeLogic: `This supports array merging. For instance, for a fr-FR user in BE, the resulting array will be a combination of the arrays from:
			- global
			- country (BE)
			- locale (fr-FR)`,
		template: ['^/p/[^/]+/?$'],
		import: false,
	});
}
